<div
  class="iconContainer"
  [style.background]="inactive ? '#E6E6E6' : therapyItem.secondaryColor"
  [style.color]="inactive ? '#ACACAC' : therapyItem.color"
>
  <ion-icon [name]="therapyItem.iconName"></ion-icon>
</div>
